import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'organization/status';

export default {
  async search() {
    const url = mountUrl(`/${BASE_PATH}`);
    return api.get(url);
  },
}; 